module.exports = __webpack_public_path__ + "6658dfd7e6da76fdcad4f511a68d3668.svg";